var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('barra'),_vm._v(" "),_c('barrais',{attrs:{"menu":{grupo: 'ecash'}}}),_vm._v(" "),_c('contenedor'),_vm._v(" "),_c('barrade'),_vm._v(" "),_c('div',{staticClass:"control-sidebar-bg"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e822fa6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ecash/operaciones/index.vue
// module id = null
// module chunks = 